/**
 * «این آدرس، سایتِ واقعی است یا نسخه‌ی توسعه؟»
 *
 * ═══ چرا لازم شد ═══
 *
 * اپِ موبایل دو نصبِ جدا دارد و از روی آیکون از هم جدا می‌شوند: اپِ اصلی
 * پس‌زمینه‌ی سرمه‌ای، «WhosUp Dev» پس‌زمینه‌ی نارنجی (نگاه کن به
 * `apps/mobile/app.config.js`). سایت این را نداشت: استیجینگ و لوکال دقیقاً
 * همان فاوآیکونِ پروداکشن را نشان می‌دادند و با چند تبِ باز هیچ راهی نبود
 * بفهمی کدام کدام است — و بدترین حالتش این است که فکر کنی روی استیجینگ
 * هستی و روی سایتِ واقعی کلیک کنی (WHOSUP-225).
 *
 * ═══ چرا «هرچه در فهرست نیست، توسعه است» و نه برعکس ═══
 *
 * فهرستِ زیر دامنه‌های واقعی است و هر چیزِ دیگری — لوکال، پیش‌نمایشِ هر شاخه‌ی
 * Cloudflare Pages، آدرسی که فردا ساخته می‌شود — غیرِ پروداکشن حساب می‌شود.
 * جهتِ اشتباه این‌طوری بی‌ضرر است: نهایتاً یک محیطِ تستی آیکونِ نارنجی
 * می‌گیرد. اگر برعکس بود (فهرستِ محیط‌های تست)، اولین شاخه‌ی تازه بی‌صدا
 * آیکونِ پروداکشن می‌گرفت — یعنی دقیقاً همان گمراهی‌ای که این کار می‌خواهد
 * ببندد.
 *
 * `goout-1e4.pages.dev` (بدونِ زیردامنه) عمداً در فهرستِ پروداکشن است: آن
 * آدرسِ شاخه‌ی اصلیِ پروژه‌ی Pages است و همان بسته‌ی پروداکشن را سرو می‌کند؛
 * `dev.goout-1e4.pages.dev` استیجینگ است و در فهرست نیست.
 *
 * فقط دربارهٔ **سایت** (`apps/web`) حرف می‌زند. اپِ ادمین آیکونِ جداگانه‌ی
 * خودش را دارد و اصلاً از این تابع رد نمی‌شود.
 */

/** دامنه‌های واقعیِ سایت — بدونِ `www.`، که جداگانه برداشته می‌شود. */
export const PRODUCTION_SITE_HOSTS: readonly string[] = [
  'outami.com',
  // دو دامنه‌ی قبلی عمداً زنده مانده‌اند و همان اپ و همان دیتابیس را سرو
  // می‌کنند، پس پروداکشن‌اند نه چیزِ دیگر.
  'palsandplans.com',
  'whosup.ca',
  // آدرسِ شاخه‌ی اصلیِ پروژه‌های Pages.
  'goout-1e4.pages.dev',
  'outami.pages.dev',
];

/**
 * @param hostname فقط میزبان، بدونِ پروتکل و پورت — یعنی `location.hostname`.
 */
export function isProductionSiteHost(hostname: string): boolean {
  // میزبان در URL بی‌توجه به بزرگی‌وکوچکیِ حروف است، و نقطه‌ی پایانی («ریشه‌ی
  // مطلقِ DNS») در بعضی کلاینت‌ها واقعاً ظاهر می‌شود.
  const host = hostname.trim().toLowerCase().replace(/\.$/, '').replace(/^www\./, '');
  return PRODUCTION_SITE_HOSTS.includes(host);
}
